<app-int-module></app-int-module>
<app-int-profile></app-int-profile>
<app-int-setting></app-int-setting>
<app-int-logout></app-int-logout>
